import Enumerator from '../global/Enumerator';

export const productSuitabilityOptions = ['none', 'not_unsuitable', 'unsuitable'];

export class ProductSuitabilityOption extends Enumerator {
  static default() {
    return this.of('none');
  }

  static of(option?: string) {
    let correctOption = option;
    switch (option) {
      case 'false':
        correctOption = 'not_unsuitable';
        break;
      case 'true':
        correctOption = 'unsuitable';
        break;
      default:
        break;
    }
    return this.enumValueOf(correctOption) || this.default();
  }
}

ProductSuitabilityOption.initEnum({
  none: {
    get title() {
      return 'None';
    }
  },
  not_unsuitable: {
    get title() {
      return 'Not unsuitable';
    }
  },
  unsuitable: {
    get title() {
      return 'Unsuitable';
    }
  }
});

export default {
  productSuitabilityOptions,
  ProductSuitabilityOption
};
